import { TransactionStateHistory } from "./transactionStateHistory";

export class Transaction {
    id: string;
    paymentMeanId: string;
    maskedPan: string;
    walletId: string;
    pumpNumber: number;
    posId: number;
    supplierId: number;
    merchantId: number;
    supplierRef: string;
    merchantRef: string;
    amount: number;
    currency: string;
    quantity: number;
    unitOfMeasure: string;
    status: string;
    transactionStateHistory: Array<TransactionStateHistory>;
    transactionState: string;
    paymentTransactionId: string;
    productType: string;
    productCode : string;
    description : string;
    vatAmount: number;
    taxPercentage: number;
    unitPrice: number;
    completionDate: string;
    lastModifiedDate: string;
    createdDate: string;
    createdBy: string;
    lastModifiedBy: string;
    dataSent: boolean;
    invoiceId: string;
}
